export default "__VITE_ASSET__CI6amjqL__"